import React, { useEffect, useRef } from "react";
import { Col, Container, Row } from "reactstrap";

export default function Photos() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  const swiperRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  useEffect(() => {
    // Wait for Swiper to be available globally
    if (typeof window !== "undefined" && window.Swiper && swiperRef.current && !swiperInstanceRef.current) {
      swiperInstanceRef.current = new window.Swiper(swiperRef.current, {
        initialSlide: 2,
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      });
    }

    // Cleanup
    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
        swiperInstanceRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <div
        style={{
          backgroundColor: "#000",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <Container>
          <Row>
            <Col lg={12}>
              <div
                ref={swiperRef}
                className="swiper mySwiper"
                style={{
                  padding: size ? "3rem 0" : "2rem 0",
                }}
              >
                <div className="swiper-wrapper">
                  {images.map((i) => (
                    <div
                      key={i}
                      className="swiper-slide"
                      style={{
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        width: size ? "50%" : "80%",
                        height: "100%",
                      }}
                    >
                      <img
                        src={require(`assets/photos/${i}`)}
                        width="100%"
                        alt="Saifee"
                        style={{
                          borderRadius: "12px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

const images = ["_DSC0685.jpg",
  "2ND ANNUAL ANZ DIGITAL TWIN 2025 INFRASTRUCTURE  CITIES  UTILITIESBrisbane_29_05_2025-235.jpg",
  "A7402189.jpg",
  "A7402253.jpg",
  "DSC00011.jpg",
  "DSC00095.jpg",
  "DSC00152.jpg",
  "SaifeeEvents82.jpg",
  "SaifeeEvents86.jpg",
  "SaifeeEvents95.jpg",
  "SaifeeEvents135.jpg",
  "SaifeeEvents158.jpg",
  "SaifeeEvents175.jpg",
  "SaifeeEvents243.jpg",
  "SaifeeEvents264.jpg", "_ME10685.jpg",
  "_ME10758.jpg",
  "_ME10762.jpg",
  "_ME10763.jpg",
  "_ME10767.jpg",
  "_ME10902.jpg",
  "_ME10908.jpg",
  "_ME10936.jpg",
  "_ME10984.jpg",
  "_ME11056.jpg",
  "_ME11101.jpg",
  "_ME11200.jpg",
  "_ME11291.jpg",
  "_ME11300.jpg",
  "_ME11340.jpg",
  "_ME11432.jpg",];
